<template>
	<v-container>
		<v-row>
			<v-col>
				<v-row>
					<v-col>
						<file-upload
							height="100%"
							end-point="/api/v0/policytransitionstatistics/expected"
							upload-name="expected-transitions"
							:title="$gettext('Expected Policy Transition Statistics')"
							:inputs="['expected transitions']"
							accept=".csv"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-card
							height="100%"
							class="d-flex flex-column"
						>
							<v-card-title>
								<translate>
									Generate New Policy Transitions
								</translate>
							</v-card-title>
							<v-card-text>
								<translate>
									This will take approximately two minutes.
								</translate>
							</v-card-text>
							<v-card-actions
								class="justify-self-end"
							>
								<v-btn
									:disabled="loading"
									:loading="loading"
									color="error"
									block
									@click="generate"
								>
									<translate>
										Generate
									</translate>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6">
				<policy-transitions-queries />
			</v-col>
		</v-row>
	</v-container>
	<report-page
		get-url="/bo/report/datascience/policytransitions"
		:title="$gettext('Policy Transitions Data Export')"
		export-filename="policy_transitions_data_export"
		:show="false"
	/>
</template>

<script>
import FileUpload from '../../../../../molecules/FileUpload.vue';
import {
	axios,
} from '../../../../../../services/axios-service';
import PolicyTransitionsQueries from '../../../../../molecules/PolicyTransitionsQueries.vue';

export default {
	name: 'DatasciencePolicytransitionExport',
	components: {
		PolicyTransitionsQueries,
		FileUpload
	},
	data () {
		return {
			loading: false,
			device: null
		};
	},
	methods: {
		/**
		 * Generate new policy transitions
		 */
		generate () {
			this.loading = true;
			axios.post('/api/v0/policytransitionstatistics/generate').then(() => {
				window.location.reload();
			}).finally(() => {
				this.loading = false;
			});
		}
	}
};
</script>
